import React, { Suspense } from 'react';
import { useParams } from 'react-router';

import { EditCompany as EditCompanyView } from '@modules/Companies/views';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';


export const EditCompany: React.FC = () => {

  const { companyId = '' } = useParams();

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <EditCompanyView companyId={parseInt(companyId, 10)}/>
      </Suspense>
    </ErrorBoundary>
  );
};
